import '.au{pointer-events:none;}.ssr-plugin'
import '.em{display:inline-flex;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.gc{stroke-width:10px;}.ssr-plugin'
import '.gd{transform:rotate(-90deg);}.ssr-plugin'
import '.ge{transform-origin:50px 50px;}.ssr-plugin'
import '.gf{transition:all 250ms ease;}.ssr-plugin'
import '.gg{stroke-linecap:round;}.ssr-plugin'
import { colors } from '../../tokens/colors.js'
import { Style, styled } from 'inlines'

type LoaderProps = {
  value?: number
  color?: 'neutral' | 'red' | 'inverted'
  size?: number
  style?: Style
}

function Loader({ value, color = 'neutral', style, size = 24 }: LoaderProps) {
  const infinite = typeof value !== 'number'

  if (!infinite && (value < 0 || value > 100)) {
    throw new Error('Value should be between 0 and 100')
  }

  if (infinite) {
    return (
      <styled.div className="au em c d"
        style={{
          height: size,
          width: size,
          ...style,
        }}
      >
        <svg
          fill="none"
          viewBox="0 0 100 100"
          style={{ width: size, height: size }}
        >
          <defs>
            <linearGradient
              id="gradient-neutral"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor={colors.neutral100} stopOpacity="0" />
              <stop
                offset="50%"
                stopColor={colors.neutral100}
                stopOpacity="0.4"
              />
              <stop
                offset="100%"
                stopColor={colors.neutral100}
                stopOpacity="1"
              />
            </linearGradient>
            <linearGradient
              id="gradient-red"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stopColor={colors.red100} stopOpacity="0" />
              <stop offset="50%" stopColor={colors.red100} stopOpacity="0.4" />
              <stop offset="100%" stopColor={colors.red100} stopOpacity="1" />
            </linearGradient>
            <linearGradient
              id="gradient-inverted"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop
                offset="0%"
                stopColor={colors.neutralInverted100}
                stopOpacity="0"
              />
              <stop
                offset="50%"
                stopColor={colors.neutralInverted100}
                stopOpacity="0.4"
              />
              <stop
                offset="100%"
                stopColor={colors.neutralInverted100}
                stopOpacity="1"
              />
            </linearGradient>
          </defs>
          <styled.circle
            cx={50}
            cy={50}
            r={45}
            stroke={`url(#gradient-${color})`}
            strokeWidth={10}
            strokeDasharray={`${(2 / 3) * 100 * ((45 * 2 * Math.PI) / 100)} ${45 * 2 * Math.PI}`}
            strokeLinecap="round"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              values="270 50 50; 90 50 50; -90 50 50"
              keyTimes="0; 0.5; 1"
              dur="1s"
              repeatCount="indefinite"
              calcMode="linear"
            />
          </styled.circle>
        </svg>
      </styled.div>
    )
  }

  return (
    <styled.div className="au em c d"
      style={{
        height: size,
        width: size,
        ...style,
      }}
    >
      <svg
        fill="none"
        viewBox="0 0 100 100"
        style={{ width: size, height: size }}
      >
        <circle className="gc"
          cx={50}
          cy={50}
          r={45}
          style={{
            stroke:
              color === 'inverted'
                ? colors.neutralInverted20
                : color === 'red'
                  ? colors.red20
                  : colors.neutral20,}}
        />
        <circle className="gd ge gc gf gg"
          cx={50}
          cy={50}
          r={45}
          style={{
            stroke:
              color === 'inverted'
                ? colors.neutralInverted100
                : color === 'red'
                  ? colors.red100
                  : colors.neutral100,
            strokeDasharray: `${value * ((45 * 2 * Math.PI) / 100)} ${45 * 2 * Math.PI}`,}}
        />
      </svg>
    </styled.div>
  )
}

export { Loader }
export type { LoaderProps }
